// extracted by mini-css-extract-plugin
export default {"body":"NotificationList_body__p7jsr","date":"NotificationList_date__KwspL"};